import { defineMessages } from 'react-intl';

export default defineMessages({
    
    basementAreaFinished:{
        id: 'tfpa.policyChange.views.Basement Area Finished (Square Feet)  ',
        defaultMessage: 'Basement Area Finished (Square Feet)'
    },
    basementAreaUnfinished:{
        id: 'tfpa.policyChange.views.Basement Area Unfinished (Square Feet) ',
        defaultMessage: 'Basement Area Unfinished (Square Feet)'
    },
    foundationType:{
        id: 'tfpa.policyChange.views.PleaseChoose',
        defaultMessage: '--Please Select--'
    },
    livingAreaSquareFootage:{
        id: 'tfpa.policyChange.views.Living Area Square Footage',
        defaultMessage: 'Living Area Square Footage'
    }, 
    serialNumber: {
       id: 'tfpa.policyChange.views.Serial Number',
       defaultMessage: 'Serial Number'
    },
    model:{
       id: 'tfpa.policyChange.views.Model',
       defaultMessage: 'Model'
    },
    make: {
       id: 'tfpa.policyChange.views.Make',
   defaultMessage: 'Make'
    },
    width: {
       id: 'tfpa.policyChange.views.Width',
       defaultMessage: 'Width'
    },
    length: {
       id: 'tfpa.policyChange.views.Length',
       defaultMessage: 'Length'        
    },
    no: {
       id: 'tfpa.policyChange.tfpa.No',
       defaultMessage: 'No'
    },
    yes: {
       id: 'tfpa.policyChange.tfpa.Yes',
       defaultMessage: 'Yes'
    },
    yearBuilt: {
        id: 'tfpa.policyChange.views.Year Built',
       defaultMessage: 'Year Built'
    }
});
